import axios from 'axios';
import routes from 'app/routes';

export default {
  delete: (reportContentId, onSuccess) => {
    axios
      .delete(routes.api.report_contents.destroy(reportContentId))
      .then((_resp) => {
        onSuccess();
      });
  },
};
